import {useSelector} from 'react-redux';
import {useFirestoreConnect} from 'react-redux-firebase';
import {allTrainingsQuery} from '../logic/firestore';
import {getCurrentAthleteId} from '../store/athleteSlice';

export const useTrainingScreenConnect = () => {
  const athleteId = useSelector(getCurrentAthleteId);
  useFirestoreConnect([allTrainingsQuery(athleteId)]);
};
